import QuestionnaireDetails from './QuestionnaireDetails';

export default QuestionnaireDetails;
